import axios from 'axios';

// Add a request interceptor
axios.interceptors.request.use(function (config) {
  const token = localStorage.getItem('jhi-authenticationToken') || sessionStorage.getItem('jhi-authenticationToken');


  if (config.url) {
    // config.baseURL = 'http://localhost:8080/';
    config.baseURL = `${process.env.VUE_APP_API_URL}`;
  }

  if (config.headers && !config.headers.Authorization && config.url) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
}, function (error) {
  return Promise.reject(error);
});

// Add a response interceptor
axios.interceptors.response.use(function (response) {
  // Any status code that lie within the range of 2xx cause this function to trigger
  // Do something with response data
  return response;
}, function (error) {
  // Any status codes that falls outside the range of 2xx cause this function to trigger
  // Do something with response error
  return Promise.reject(error);
});

